import React from "react";
import { useTranslation } from "react-i18next";
import { metricDelta } from "./previousPeriod";

export default function TimeChange({
  current,
  previous,
  label,
}: {
  current: number;
  previous: number;
  label?: string;
}) {
  const { t } = useTranslation();
  const delta = metricDelta(current, previous, true);
  return (
    <span
      className="inline-block whitespace-nowrap text-right text-xs font-medium tabular-nums text-text-mid"
      title={delta === null ? t("dashboard.no_previous_data") : label}
      aria-label={
        delta === null
          ? t("dashboard.no_previous_data")
          : `${delta}. ${label ?? t("dashboard.delta_previous")}`
      }
    >
      {delta ?? "—"}
    </span>
  );
}
